import { inject, Injectable, Signal } from '@angular/core';
import { ISubscriptionTicket } from '@web/dtos';
import { SubscriptionTicketsStore } from '../api/subscription/subscription-store.service';

@Injectable({ providedIn: 'root' })
export class CmsSubscriptionTicketService {
  private readonly subscriptionTicketsStore: SubscriptionTicketsStore = inject(
    SubscriptionTicketsStore
  );

  public readonly subscriptions: Signal<ISubscriptionTicket[]> =
    this.subscriptionTicketsStore.subscriptions;
  public readonly isLoading: Signal<boolean> =
    this.subscriptionTicketsStore.isLoading;

  public reloadSubscriptions(): void {
    this.subscriptionTicketsStore.reloadSubscriptionTickets();
  }
}
